import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import LinkElment from "@mui/material/Link";
import { Navigate } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

export const Maintenance = () => {
  const { maintenanceMode } = useFlags();

  if (!maintenanceMode) return <Navigate to="/" replace />;

  return (
    <Stack
      sx={{
        minHeight: "100dvh",
      }}
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="h5" fontWeight={600} textAlign="center" paddingX="16px">
        Look’s like the power’s out.
      </Typography>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        sx={{
          width: "100%",
          maxWidth: "696px",
          paddingX: "16px"
        }}
      >
        We’re currently under maintenance. In the meantime you can contact{" "}
        <LinkElment href="mailto:customerservice@gofreedompower.com">
          customerservice@gofreedompower.com
        </LinkElment>{" "}
        , for further assistance.
      </Typography>
    </Stack>
  );
};
